import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faUser,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import { cn } from "app/lib/utils";

interface GoalTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  availableTypes: string[];
}

export default function GoalTypeSelector({
  value,
  onChange,
  label = "What type of goal is this?",
  availableTypes,
}: Readonly<GoalTypeSelectorProps>) {
  const goalTypeLabelMap: Record<
    string,
    {
      label: string;
      iconProp: IconProp;
    }
  > = {
    personal: { label: "Personal", iconProp: faUser },
    work: { label: "Work", iconProp: faBriefcase },
    team: { label: "Team", iconProp: faUsers },
  };

  const getGoalTypeSelectorButtons = () => {
    const classNames = {
      active: {
        button: "border-sapphire-100 bg-sapphire-05",
        icon: "text-sapphire-100",
        text: "text-sapphire-130",
      },
      inactive: {
        button:
          "hover:border-charcoal-30 hover:bg-charcoal-05 border-charcoal-20",
        icon: "text-charcoal-60",
        text: "text-charcoal-130",
      },
    };
    return availableTypes.map((type) => {
      const active = value === type;
      return (
        <button
          key={type}
          onClick={() => onChange(type)}
          className={cn(
            "flex-1 border-[1px] rounded-[8px] px-[8px] py-[14px] transition-colors",
            active ? classNames.active.button : classNames.inactive.button
          )}
        >
          <FontAwesomeIcon
            icon={goalTypeLabelMap[type].iconProp}
            className={
              active ? classNames.active.icon : classNames.inactive.icon
            }
          />
          <p
            className={
              active ? classNames.active.text : classNames.inactive.text
            }
          >
            {goalTypeLabelMap[type].label}
          </p>
        </button>
      );
    });
  };

  return (
    <div className="gm-field">
      <p className="text-form-prompt font-medium text-primary-text">{label}</p>
      <div className="d-flex gap-2 flex-col sm:flex-row ">
        {getGoalTypeSelectorButtons()}
      </div>
    </div>
  );
}
